/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { string, object, func } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    phoneBlock: {
        display: 'block',
        fontFamily: theme.typography.fontFamily,
    },
    heading: {
        textAlign: 'center',
        fontSize: '18px',
        color: 'black',
    },
    cutOffMessages: {
        textAlign: 'center',
        fontSize: '14px',
        color: theme.palette.bgHeader,
        padding: '10px 0px',
    },
    phoneIcon: {
        '& img': {
            width: '45px',
        },
    },
});

const PhoneBlock = ({
    heading, classes, cutOffMessages, phoneIcon, phoneNumber, trackEvent,
}) => (
    <div className={classes.phoneBlock}>
        <div className={classes.heading}>
            { heading }
        </div>
        <div className={classes.cutOffMessages}>
            { cutOffMessages }
        </div>
        <div className={classes.cutOffMessages}>
            <span className={classes.phoneIcon}>
                <a
                    href={phoneNumber}
                    onClick={() => {
                        trackEvent({
                            eventCategory: 'HomePage',
                            eventAction: 'Call',
                            eventLabel: 'Homepage',
                        });
                    }}
                >
                    <img src={phoneIcon?.url} alt={phoneIcon?.content_type} aria-hidden />
                </a>
            </span>
        </div>
    </div>
);

PhoneBlock.propTypes = {
    heading: string.isRequired,
    cutOffMessages: string.isRequired,
    classes: object.isRequired,
    phoneIcon: object.isRequired,
    phoneNumber: string.isRequired,
    trackEvent: func.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default  connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(PhoneBlock));
